<template>
  <div>
    <template v-if="selectedPost">
      <ul class="post-list">
        <template v-for="(post, index) in posts">
          <li :class="['post-item', selectedPost.id === post.id ? 'is-active' : '']" @click="select(post)">
            <p class="post-title">{{ post.title.rendered }}</p>
            <p class="post-slug">/{{ post.slug }}</p>
            <time class="post-date"><i class="fa fa-fw fa-calendar" aria-hidden="true"></i>{{ dateFormat(post.date) }}</time>
          </li>
        </template>
      </ul>
    </template>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'post-list',
  props: ['posts', 'selectedPost'],
  methods: {
    dateFormat (date) {
      return moment(date).format('YYYY年M月D日')
    },
    select: function (post) {
      this.$emit('select', post)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~scss/variables';
@import '~scss/theme';

.post {
  &-list {
    margin: 0;
    width: $app_post_list_width;
  }
  &-item {
    padding: 2em;
    cursor: pointer;
    &:nth-of-type(odd) {
      // background-color: $--color-light-gray;
    }
    &:nth-of-type(even) {
      // background-color: $--color-extra-light-gray;
    }
    &:hover {
      border-left: 5px solid $--color-primary;
      background-color: $--color-base-gray;
      transition: all 300ms;
    }
    &.is-active {
      border-left: 5px solid $--color-primary;
      background-color: $--color-base-gray;
    }
  }
  &-title,
  &-slug {
    margin: 0;
  }
  &-title {
    font-size: .85em;
    font-weight: bold;
    color: #000;
  }
  &-slug {
    font-size: .75em;
  }
  &-date {
    display: block;
    text-align: right;
    & .fa {
      margin-right: .5em;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/app/PostList.vue